import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {fromEvent, Subscription, UnsubscriptionError} from "rxjs";
import {AppComponent} from "../../app.component";
import {Module} from "../../models/module.model";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent implements OnInit {
  is_sidebar_visible = false;
  resize_subscription: Subscription | undefined;
  global_texts: any = null;
  modules: Module[] = [];

  constructor(public app: AppComponent) {
  }

  ngOnDestroy() {
    if (this.resize_subscription) {
      this.resize_subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    // Get the modules from the server when BDD is ready
    this.app.sharedHelper.getModulesData().subscribe((resp_all_modules: any) => {
      this.modules = resp_all_modules.data;
      console.log("getModulesData resp_all_modules => ", this.modules);
    });

    // Responsive sidebar
    this.is_sidebar_visible = window.innerWidth > 1024;
    this.getAllContentStatic(this.is_sidebar_visible);

    this.resize_subscription = fromEvent(window, 'resize').subscribe(() => {
      this.is_sidebar_visible = window.innerWidth > 1024;
      this.getAllContentStatic(this.is_sidebar_visible);
    });

    this.app.sharedHelper.getGlobalTexts().subscribe((texts: object) => {
      this.global_texts = texts;
    });
  }

  toggleSidebar() {
    this.is_sidebar_visible = !this.is_sidebar_visible;
    this.getAllContentStatic(this.is_sidebar_visible);
  }

  getAllContentStatic(_isSidebarVisible: boolean) {
    let allContent = document.getElementsByClassName('all-content');
    //console.log('allContent ==> ', allContent);
    //console.log("_isSidebarVisible ==> ", _isSidebarVisible);
    // console.log("this.is_sidebar_visible ==> ", this.is_sidebar_visible);
    if (allContent && window.innerWidth < 992) {
      if (!_isSidebarVisible) allContent[0].classList.remove('all-content-static');
      else allContent[0].classList.add('all-content-static');
    }
  }
}
